import { ValidationObserver, ValidationProvider } from "vee-validate";
import { v4 as uuidv4 } from 'uuid';
import { MailingMethods } from "@/enums/MailingMethods";

export default {
  name: "AddContatDialog",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      to: {
        id: uuidv4(),
        name: "",
        surname: "",
        email: ""
      },
      mailingMethods: MailingMethods,
      mode: MailingMethods.Manual,
      csv: null,
      csvData: null,
      filename: null,
      isError: false,
      errorContent: ""
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      if(this.mode === this.mailingMethods.Manual) {
        this.checkIfUserAlreadyAdded();
      } else if(this.mode === this.mailingMethods.CSV) {
        this.checkIfImportByCSV();
      }

      await this.$store.dispatch("updateFacilityMailingLists", this.mailing);

      this.to = {
        id: uuidv4(),
        name: "",
        surname: "",
        email: ""
      };
      this.$refs.addContactForm.reset();
      this.dialog = false;
      this.loading = false;
      this.csv = null;
      this.csvData = null;
    },
    checkIfUserAlreadyAdded() {
      if(!this.mailing.to.find(x => x.email === this.to.email)) {
        this.mailing.to.push(this.to);
      }
    },
    checkIfImportByCSV(){
      if(!this.mailing.method.includes(this.mailingMethods.CSV)) {
        this.mailing.method = this.mailing.method + "+" + this.mailingMethods.CSV;
      }

      this.csvData.forEach(item => {
        if(!this.mailing.to.find(x => x.email === item.email)) {
          this.mailing.to.push({
            id: uuidv4(),
            email: item["Email"],
            name: item["First Name"],
            surname: item["Last Name"] ? item["Last Name"] : ""
          });
        }
      });
    },
    open() {
      this.dialog = true;
      this.mode = this.mailingMethods.Manual;
    },
    close() {
      this.dialog = false;
      this.filename = null;
      this.csv = null;
      this.csvData = null;
    },
    onLoadFile(e) {
      if (!e || !e.currentTarget || !this.$papa || !this.$papa.parse) return

      const file = e.currentTarget.files[0]

      this.filename = file.name

      this.$papa.parse(file, {
        header: true,
        complete: this.onComplete,
        skipEmptyLines: true,
      })
    },
    onComplete(results, file) {
      this.clearError();

      if(file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
        const message = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseUploadaCSVFile']
        this.setError(message);
        return false;
      }

      if(!results.meta.fields.includes("Email") || !results.meta.fields.includes("First Name")) {
        const message = this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.PleaseUploadaCSVFileByFollowingFormat'] + "Email,First name,Last name (optional)";
        this.setError(message);
        return false;
      }

      this.csv = results;
      this.csvData = results.data;
    },
    clearError() {
      this.isError = false;
      this.errorContent = "";
    },
    setError(message) {
      this.isError = true;
      this.errorContent = message;
      this.filename = null;
      this.csv = null;
      this.$refs.input.focusout;
    }
  },
  computed: {
    mailing() {
      return this.$store.state.facilityModule.facilityMailingCurrent;
    },
    isManual() {
      return this.mode === this.mailingMethods.Manual;
    }
  },
}